/**
 * values for setting the 'format' in address fields
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const ADDRESS_FORMAT = {
  UK:'uk',
  US:'us',
  INTERNATIONAL:'gl',
};

const ADDRESS_FORMAT_ALL = _.values(ADDRESS_FORMAT, 'value');

const ADDRESS_FORMAT_LIST = [
  {text: locale('United Kingdom'), value: ADDRESS_FORMAT.UK, description: ''},
  {text: locale('United States'), value: ADDRESS_FORMAT.US, description: ''},
  {text: locale('International'), value: ADDRESS_FORMAT.INTERNATIONAL, description: ''},
]

export { ADDRESS_FORMAT, ADDRESS_FORMAT_LIST, ADDRESS_FORMAT_ALL};

export default ADDRESS_FORMAT;